export default "__VITE_ASSET__CkzDdHDp__"